import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertDocumentOversightResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDocumentOversightResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertDocumentOversightResultInput = {
  OversightAssessmentId: string;
  DocumentIds: string[];
  // COI-650: V2 required Rating on this insert; the form schema has always
  // made it mandatory, so the type now matches.
  Rating: number;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertDocumentOversightResult = createMutationHook({
  name: 'insertDocumentOversightResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.insertDocumentOversightResult.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertDocumentOversightResultInput) => input,
  invalidate: (trpc) => [
    // Apollo parity: evictField(cache, 'document_oversight_result')
    trpc.frontend.assessment.getOversightResultsByParentId.pathKey(),
    trpc.frontend.assessment.getAllOversightAssessmentResults.queryKey(),
    trpc.frontend.assessment.oversightResultById.pathKey(),
    trpc.frontend.assessment.documentOversightResultById.pathKey(),
    trpc.frontend.assessment.oversightAssessmentDocumentAssessmentResultsByDocumentId.pathKey(),
    // Apollo parity: evictField(cache, 'document_oversight_result_aggregate')
    trpc.frontend.assessment.oversightAssessmentResultCount.queryKey(),
    // Apollo parity: evictField(cache, 'oversight_assessment')
    trpc.frontend.assessment.oversightActivityRegister.queryKey(),
    trpc.frontend.assessment.oversightActivityCount.queryKey(),
  ],
  mapResponse: (result: {
    Ids: string[];
  }): InsertDocumentOversightResultMutation => ({
    insertChildDocumentOversightResult: {
      __typename: 'InsertChildDocumentAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  graphqlDocument: InsertDocumentOversightResultDocument,
  graphqlVariables: (input: InsertDocumentOversightResultInput) => input,
  evictFields: [
    'document_oversight_result',
    'oversight_assessment',
    'document_oversight_result_aggregate',
  ],
});
